module.exports = __webpack_public_path__ + "img/logo.644782c6.svg";